<template>
  <div>
    <div class="hero-section">
      <div class="d-flex justify-content-center align-items-center hero-content">
        <div class="sub-text ">
          <h2 class="text-white text-center">Co-Workspace</h2>
          <p class="text-white text-center small">
            We provide a conducive and comfortable co-workspace for you
          </p>
       
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center cowork-section my-5">
      <div class="container">
        <div class="row">
          <div class="what-text col-lg-5 col-md-6 col-sm-12 p-5">
            <h3 class="pb-4">What is a Co-workspace?</h3>
            <p>A co-workspace, also known as a co-working space, is a shared office space where individuals and businesses can rent a desk, a private office, or a meeting room on a short-term basis. Co-workspaces are designed to provide a collaborative and productive environment for freelancers, entrepreneurs, start-ups, and remote workers who may not have access to a traditional office setting or who prefer to work in a community of like-minded individuals.</p>
          </div>
          <div class="what-img col-lg-5 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <img src="../assets/Images/co-work.png" class="img-fluid">
          </div>
        </div>
      </div>
    </div>

     <div class="d-flex align-items-center justify-content-center cowork-section my-5 ">
      <div class="container">
        <div class="row">
           <div class="what-img col-lg-5 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <img src="../assets/Images/whypic.png" class="img-fluid what-why-img">
          </div>
          <div class=" col-lg-5 col-md-6 col-sm-12 ">
            <h3 class="pb-4  pt-4 text-center why-text">Why Fhenix’s Co-workspace?</h3>
           <ul style="width:100%">
             <ol class="">
              <bold>1 Networking Opportunities:</bold>
               Co-workspaces bring together professionals from different backgrounds and industries, providing ample opportunities to network, collaborate, and build professional relationships. This can lead to new business opportunities, partnerships, and referrals.
              </ol>

              <ol>
                <bold>2 Cost-Effective:</bold> Co-workspaces can be a more cost-effective option than traditional office spaces, as members only pay for the space they need on a flexible basis. This can be particularly beneficial for freelancers or start-ups who may not have the budget for a dedicated office space.
               </ol> 
               <ol>
                <bold>3 Flexibility:</bold> Co-workspaces offer members the flexibility to work on their own schedule, without the constraints of a traditional 9-to-5 workday. Members can also choose the type of workspace that suits their needs, whether it be a private office, a dedicated desk, or a shared space.
                </ol>

                <ol>
                 <bold>4 Amenities:</bold> Co-workspaces typically offer a range of amenities, such as high-speed internet, printers, scanners, conference rooms, and kitchen facilities, which can help members work more efficiently and productively.
                 </ol>

                 <ol>
                 <bold>5 Community:</bold> Co-workspaces foster a sense of community and provide opportunities for social interaction and support. This can be particularly valuable for remote workers or freelancers who may otherwise feel isolated.
             
                 </ol> 
           </ul>
          </div>
         
        </div>
      </div>
    </div>

    
  </div>
</template>

<style scoped>
.hero-section {
  background-image: url(../assets/Images/product.png);
  min-height: 90vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.hero-content {
  min-height: 90vh;
}

.hero-content h2 {
  font-size: 64px;
  font-weight: 700;
  font-family: inter;
  font-style: normal;
}

.hero-content p {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
}
.sub-text {
  width: 45%;
}

ul{
  color: #595959;
}

ol{
  padding-bottom:7px;
  font-size: 17px;
  line-height: 27px;
  font-weight:400;
  font-family: inter;
}

bold{

color: #006EC3;
Font:Inter;
font-Weight:600;
font-Size: 20px;
Line-height: 30px;

}

@media (max-width: 991px) {
  .hero-content h2 {
    font-size: 32px;
  }

  .hero-content p {
     font-siz: ;
  }
  .sub-text {
    width: 60% !important;
  }
}

@media (max-width: 767px) {
  .hero-section {
    min-height: 40vh;
  }
  .hero-content {
    min-height: 40vh;
  }
  .hero-content h2 {
    font-size: 24px;
  }
  .sub-text {
    width: 50% !important;
  }
  .what-text {
    padding: 20px;
    
  }
  .what-img {
    margin-top: 20px;
  }

 


 
}

@media (max-width: 575px) {
  .hero-section {
    min-height: 30vh;
  }
  .hero-content {
    min-height: 30vh;
  }
  .hero-content h2 {
    font-size: 20px;
  }
  .sub-text {
    width: 90% !important;
  }
  .what-text {
    padding: 10px;
  }

  why-text{
    margin-top: 20px; 
  }

    .what-img img {
    width: 500px;
    margin-left: 70px;
  }
}
</style>